import { useEffect } from "react";
import axios from "axios";
import { useLoading } from "../context/LoadingContext";

const AxiosInterceptor = () => {
  const { startLoading, stopLoading } = useLoading();

  useEffect(() => {
    const reqInterceptor = axios.interceptors.request.use(
      (config) => {
        startLoading();
        return config;
      },
      (error) => {
        stopLoading();
        return Promise.reject(error);
      }
    );

    const resInterceptor = axios.interceptors.response.use(
      (response) => {
        stopLoading();
        return response;
      },
      (error) => {
        stopLoading();
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.request.eject(reqInterceptor);
      axios.interceptors.response.eject(resInterceptor);
    };
  }, [startLoading, stopLoading]);

  return null;
};

export default AxiosInterceptor;
